/**
 * is-opened=true аттрибут говорит что панель открыта
 */
const SELECTOR = '#mobile-panel div[is-opened=true]';

let RETURN_OFFSET_VALUE = 0;

const body = document.documentElement || document.body;

const hasOpened = () => document.querySelector(SELECTOR);

const fixBodyScroll = () => {
  RETURN_OFFSET_VALUE = window.pageYOffset || body.scrollTop || body.scrollTop;
  body.style.position = 'fixed';
  body.style.overflow = 'hidden';
};

const unFixBodyScroll = () => {
  body.style.position = '';
  body.style.overflow = '';
  window.scrollTo(0, RETURN_OFFSET_VALUE);
  RETURN_OFFSET_VALUE = 0;
};

const delayedCall = fn => () => setTimeout(fn, 300);

export default {
  mounted() {
    this.$nextTick(delayedCall(fixBodyScroll));
  },
  beforeDestroy() {
    /**
     * Если нет открытых панелей - удалить overflow: hidden
     */
    if (!hasOpened()) {
      this.$nextTick(unFixBodyScroll);
    }
  },
};



// WEBPACK FOOTER //
// ./src/mixins/bodyOverflow.js